/**
 * Mina sidor v2 (app/views/account-v2.view.php). Loaded only on account
 * pages, by MyAccount::assets(). Every view works without it; this adds:
 *
 * - "Visa fler": the next page of orders or purchases is fetched from
 *   versa/v1/account/* and appended, instead of following the link.
 * - The current tab of the mobile tab row is scrolled into view.
 * - "Visa" on password fields, "Skriv ut kvitto" on an order (both hidden
 *   in the markup, since without this script they would do nothing).
 * - Logged out: "skapa ett konto" / "Logga in här" switch the login card
 *   without a reload, and vapour drifts up behind it.
 */
( function () {
	'use strict';

	var config = window.versaAccount || {};

	function announce( text ) {
		if ( 'function' === typeof window.versaAnnounce ) {
			window.versaAnnounce( text );
		}
	}

	function scrollCurrentTab() {
		var tabs = document.querySelector( '.versa-account-tabs' );
		var tab = tabs && tabs.querySelector( '[aria-current]' );
		if ( tab && tabs.scrollWidth > tabs.clientWidth ) {
			var left = tab.getBoundingClientRect().left - tabs.getBoundingClientRect().left + tabs.scrollLeft;
			tabs.scrollLeft = left - ( tabs.clientWidth - tab.offsetWidth ) / 2;
		}
	}

	function passwordToggles() {
		document.querySelectorAll( '[data-account-reveal]' ).forEach( function ( button ) {
			var input = document.getElementById( button.getAttribute( 'data-account-reveal' ) );
			var label = button.querySelector( '[data-account-reveal-label]' );
			if ( ! input ) {
				return;
			}
			button.hidden = false;
			button.addEventListener( 'click', function () {
				var show = 'password' === input.type;
				input.type = show ? 'text' : 'password';
				button.setAttribute( 'aria-pressed', show ? 'true' : 'false' );
				if ( label ) {
					label.textContent = show ? 'Dölj' : 'Visa';
				}
			} );
		} );
	}

	function printButtons() {
		if ( 'function' !== typeof window.print ) {
			return;
		}
		document.querySelectorAll( '[data-account-print]' ).forEach( function ( button ) {
			button.hidden = false;
			button.addEventListener( 'click', function () {
				window.print();
			} );
		} );
	}

	// The links are real (?registrera shows the register panel server-side);
	// here they only swap the panels and keep the URL in step for a reload.
	function authSwitch() {
		var panels = document.querySelectorAll( '[data-account-auth-panel]' );
		if ( panels.length < 2 ) {
			return;
		}
		document.querySelectorAll( 'a[data-account-auth]' ).forEach( function ( link ) {
			link.addEventListener( 'click', function ( event ) {
				var target = document.querySelector( '[data-account-auth-panel="' + link.getAttribute( 'data-account-auth' ) + '"]' );
				if ( ! target ) {
					return;
				}
				event.preventDefault();
				panels.forEach( function ( panel ) {
					panel.hidden = panel !== target;
				} );
				if ( window.history && history.replaceState ) {
					history.replaceState( null, '', link.href );
				}
				var heading = target.querySelector( 'h1' );
				if ( heading ) {
					heading.focus();
				}
			} );
		} );
	}

	// Decoration only (aria-hidden box): clouds of vapour rising beside the
	// login card, as on the earlier login page.
	function vapor() {
		var box = document.querySelector( '[data-account-vapor]' );
		if ( ! box || ( window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) ) {
			return;
		}
		var card = document.querySelector( '[data-account-auth-card]' );
		var max = 35;

		function cloud() {
			if ( document.hidden || box.childElementCount >= max ) {
				return;
			}
			var width = box.offsetWidth;
			var size = Math.random() * 300 + 90;
			var large = Math.random() < 0.2;
			var x = Math.random() * width;

			// Beside the card, not behind it, where there is room for that.
			if ( card ) {
				var boxLeft = box.getBoundingClientRect().left;
				var rect = card.getBoundingClientRect();
				var left = rect.left - boxLeft - 100;
				var right = rect.right - boxLeft + 100;
				if ( left > 0 && x > left && x < right ) {
					x = Math.random() > 0.5 ? Math.random() * left : right + Math.random() * Math.max( 0, width - right );
				}
			}

			var el = document.createElement( 'div' );
			var r = function ( min, span ) {
				return ( min + Math.random() * span ).toFixed( 0 ) + '%';
			};
			var a = r( 30, 40 ), b = r( 20, 60 ), c = r( 40, 50 ), d = r( 10, 70 );
			el.className = 'versa-auth-vapor' + ( large ? ' is-large' : '' );
			el.style.width = size + 'px';
			el.style.height = size * ( 0.6 + Math.random() * 0.8 ) + 'px';
			el.style.left = x + 'px';
			el.style.borderRadius = a + ' ' + b + ' ' + c + ' ' + d + ' / ' + b + ' ' + d + ' ' + a + ' ' + c;
			el.style.setProperty( '--duration', ( large ? 25 + Math.random() * 15 : 12 + Math.random() * 8 ) + 's' );
			el.style.setProperty( '--rotation', Math.random() * 360 + 'deg' );
			el.addEventListener( 'animationend', function () {
				el.remove();
			} );
			box.appendChild( el );
		}

		for ( var i = 0; i < max; i++ ) {
			setTimeout( cloud, i * 500 );
		}
		setInterval( cloud, 1000 );
	}

	function countText( type, first, shown, total ) {
		var noun = 'orders' === type ? 'ordrar' : 'produkter';
		return first > 1
			? 'Visar ' + first + '–' + shown + ' av ' + total + ' ' + noun
			: 'Visar ' + shown + ' av ' + total + ' ' + noun;
	}

	function moreLinks() {
		if ( ! config.rest || ! window.fetch ) {
			return;
		}
		document.querySelectorAll( 'a[data-account-more]' ).forEach( function ( link ) {
			var type = link.getAttribute( 'data-account-more' );
			var box = link.closest( 'section, .overflow-hidden' );
			var list = box && box.querySelector( '[data-account-list]' );
			var count = box && box.querySelector( '[data-account-count]' );
			if ( ! list ) {
				return;
			}

			link.addEventListener( 'click', function ( event ) {
				if ( link.getAttribute( 'aria-busy' ) === 'true' ) {
					event.preventDefault();
					return;
				}
				event.preventDefault();

				var params = new URLSearchParams( { page: link.getAttribute( 'data-page' ) } );
				var query = {};
				try {
					query = JSON.parse( link.getAttribute( 'data-query' ) || '{}' );
				} catch ( e ) {}
				Object.keys( query ).forEach( function ( key ) {
					if ( query[ key ] ) {
						params.set( key, query[ key ] );
					}
				} );

				link.setAttribute( 'aria-busy', 'true' );
				fetch( config.rest + type + '?' + params.toString(), {
					credentials: 'same-origin',
					headers: { 'X-WP-Nonce': config.nonce, Accept: 'application/json' }
				} )
					.then( function ( response ) {
						if ( ! response.ok ) {
							throw new Error( String( response.status ) );
						}
						return response.json();
					} )
					.then( function ( data ) {
						var before = list.children.length;
						list.insertAdjacentHTML( 'beforeend', data.html || '' );
						var added = list.children.length - before;

						if ( count ) {
							var first = parseInt( count.getAttribute( 'data-first' ), 10 ) || 1;
							count.textContent = countText( type, first, data.shown, data.total );
						}
						if ( data.next ) {
							link.href = data.next;
							link.setAttribute( 'data-page', String( data.page + 1 ) );
							link.removeAttribute( 'aria-busy' );
						} else {
							link.remove();
						}

						// Keyboard users continue from the first new row.
						var firstNew = list.children[ before ];
						var target = firstNew && firstNew.querySelector( 'a' );
						if ( target ) {
							target.focus( { preventScroll: false } );
						}
						announce( added + ( 'orders' === type ? ' fler ordrar visas.' : ' fler produkter visas.' ) );

						if ( 'function' === typeof window.observeAddToCartButtons ) {
							window.observeAddToCartButtons( false );
						}
					} )
					.catch( function () {
						// Fall back to the plain link: the next page, server-rendered.
						window.location.href = link.href;
					} );
			} );
		} );
	}

	function init() {
		scrollCurrentTab();
		passwordToggles();
		printButtons();
		moreLinks();
		authSwitch();
		vapor();
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
